interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  overlayClassName?: string;
}

export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  size = 'md',
  className = '',
  overlayClassName = 'z-50'
}: ModalProps) {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg'
  };

  return (
    <div className={`fixed inset-0 bg-black/50 flex items-center justify-center p-4 ${overlayClassName}`}>
      <div className={`bg-white rounded-3xl w-full ${sizeClasses[size]} max-h-[90vh] overflow-y-auto shadow-2xl ${className}`}>
        {title && (
          <div className="sticky top-0 bg-white p-6 border-b border-gray-100 rounded-t-3xl">
            <div className="flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-800 font-sans">{title}</h3>
              <button
                onClick={onClose}
                className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
              >
                <i className="ri-close-line text-gray-600"></i>
              </button>
            </div>
          </div>
        )}
        <div className="p-6">
          {children}
        </div>
      </div>
    </div>
  );
}